import React from "react";
import { TextField } from "@mui/material";
import { CelularSpecs } from "../../types/types";
import { CELULAR_SPEC_LABELS, INPUT_LABEL_PROPS } from "../shared/constants";
import { FormFieldGridResponsive } from "../shared/styledComponents";

interface CelularSpecsEditorProps {
  specs: CelularSpecs;
  onChange: (specs: CelularSpecs) => void;
}

const EMPTY_SPECS: CelularSpecs = {
  procesador: null,
  sistema_operativo: null,
  ram: null,
  almacenamiento: null,
  memoria_expandible: null,
  tipo_pantalla: null,
  tamano_pantalla: null,
  propiedades_camara: null,
  bateria: null,
  factor_forma: null,
  ano_lanzamiento: null,
  precio_lanzamiento_usd: null,
  ranking_2025: null,
  ranking_historico: null,
  unidades_vendidas_estimadas: null,
};

export { EMPTY_SPECS };

const SPEC_KEYS = Object.keys(EMPTY_SPECS) as (keyof CelularSpecs)[];

const CelularSpecsEditor: React.FC<CelularSpecsEditorProps> = ({ specs, onChange }) => {
  const handleChange = (key: keyof CelularSpecs, value: string) => {
    const trimmed = value.trim();
    const isNumericField =
      key === "ano_lanzamiento" || key === "ranking_2025" || key === "ranking_historico";

    let parsed: string | number | null;
    if (trimmed === "") {
      parsed = null;
    } else if (isNumericField) {
      const num = Number(trimmed);
      parsed = Number.isNaN(num) ? trimmed : num;
    } else {
      parsed = value;
    }

    onChange({ ...specs, [key]: parsed });
  };

  return (
    <FormFieldGridResponsive>
      {SPEC_KEYS.map((key) => (
        <TextField
          key={key}
          label={CELULAR_SPEC_LABELS[key] ?? key}
          value={specs[key] ?? ""}
          onChange={(e) => handleChange(key, e.target.value)}
          size="small"
          fullWidth
          InputLabelProps={INPUT_LABEL_PROPS}
        />
      ))}
    </FormFieldGridResponsive>
  );
};

export default CelularSpecsEditor;
